import React from 'react';
import PropTypes from 'prop-types';

import ConnectCfBody from 'utils/connectCfBody';

const PageComponents = ({ body }) => {
  if (!body) return <h2>Ups.. Something went wrong with Contentful data</h2>;

  const renderComponent = component => {
    if (component.id) return <ConnectCfBody key={component.id} {...component} />;
  };

  return <>{body.map(renderComponent)}</>;
};

PageComponents.propTypes = {
  body: PropTypes.array,
};

export default PageComponents;
